import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ANALYTICS_CONSENT_KEY, disableAnalytics, initAnalytics } from '../lib/analytics';

const CookieConsent = () => {
  const [open, setOpen] = useState(() => !window.localStorage.getItem(ANALYTICS_CONSENT_KEY));

  useEffect(() => {
    const show = () => setOpen(true);
    window.addEventListener('open-cookie-settings', show);
    return () => window.removeEventListener('open-cookie-settings', show);
  }, []);

  const choose = (value) => {
    window.localStorage.setItem(ANALYTICS_CONSENT_KEY, value);
    if (value === 'granted') initAnalytics();
    else disableAnalytics();
    setOpen(false);
  };

  if (!open) return null;

  return (
    <aside
      role="dialog"
      aria-label="Analytics preferences"
      className="fixed z-[120] bottom-4 left-4 right-4 md:left-6 md:right-auto md:max-w-lg rounded-2xl border border-white/15 bg-[#111]/95 backdrop-blur-xl p-5 shadow-2xl"
    >
      <p className="font-display text-lg font-semibold text-white">Your privacy choices</p>
      <p className="mt-2 text-sm leading-relaxed text-white/65">
        We use optional analytics to understand which films and contact options are useful. Form fields are masked and analytics stays off unless you accept. See our{' '}
        <Link to="/privacy" className="text-[#c9a85f] hover:underline">privacy notice</Link>.
      </p>
      <div className="mt-4 flex flex-col-reverse sm:flex-row gap-3 sm:justify-end">
        <button onClick={() => choose('denied')} className="rounded-md border border-white/20 px-4 py-2.5 text-sm font-medium text-white hover:border-white/40">
          Essential only
        </button>
        <button onClick={() => choose('granted')} className="rounded-md bg-[#c9a85f] px-4 py-2.5 text-sm font-semibold text-black hover:bg-[#d8b970]">
          Accept analytics
        </button>
      </div>
    </aside>
  );
};

export default CookieConsent;
